import {Box, CircularProgress, Fade, Tooltip} from "@mui/material"
import {CloudDone, CloudOff} from "@mui/icons-material"

export function ProviderStatusIndicator({isLoading, connectionError, lastUpdated}) {
	return (
		<Tooltip
			title={"Last Synced: " + lastUpdated}
			enterDelay={500}
			enterNextDelay={500}
			placement="right"
			arrow
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					minHeight: "40px",
					minWidth: "40px",
					color: "action.active",
				}}
			>
				<Fade in={isLoading}>
					<CircularProgress
						variant={"indeterminate"}
						color={"inherit"}
						sx={{
							position: "absolute",
						}}
					/>
				</Fade>

				{!connectionError && (
					<CloudDone
						color={"inherit"}
						sx={{
							fontSize: "2rem",
						}}
					/>
				)}

				{connectionError && (
					<CloudOff
						color="error"
						sx={{
							fontSize: "2rem",
						}}
					/>
				)}

			</Box>
		</Tooltip>

	)
}